import(/* webpackMode: "eager", webpackExports: ["CategoryGalleryClient"] */ "/Users/christophkranebitter/renehuemer.com/website/src/components/CategoryGalleryClient.tsx");
